<template>
  <section id="dashboard">
    <v-container class="fill-height">
      <v-row>
        <v-col cols="12">
          <v-card outlined>
            <v-img
              :src="require('@/assets/illustrations/bg_dashboard_card.svg')"
              cover
              position="top"
              class="align-center"
              :max-height="welcomeCardHeight"
            >
              <v-card-title>
                <v-container fill-height fluid>
                  <v-row align="center" justify="space-between" dense>
                    <v-col cols="12" md="9">
                      <h2
                        :class="[isMobile ? 'h3' : 'h2', isMobile && isDark ? 'white--text' : 'primary--text']"
                        style="word-break: normal"
                      >
                        ¡Hola, {{ userData.name }}!
                      </h2>
                      <p style="word-break: normal; line-height: normal">
                        Bienvenido de vuelta a PBXBerry. Ten una buena jornada productiva.
                      </p>
                    </v-col>

                    <v-col cols="3" class="d-none d-md-block">
                      <v-img
                        contain
                        max-width="90%"
                        class="mx-auto"
                        :src="require('@/assets/illustrations/agent.svg')"
                        alt="Chart illustration"
                      ></v-img>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-title>
            </v-img>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="d-none d-md-flex">
        <v-col v-if="showAgentCall" cols="12" sm="6" md="4">
          <v-card flat class="bg-0 d-flex align-center" height="100px" @click="openDialerDialog">
            <v-list-item>
              <v-list-item-avatar tile>
                <img src="@/assets/images/home-buttons/3.png" alt="icon" />
              </v-list-item-avatar>

              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Marcar</v-list-item-title>

                <!-- <v-list-item-subtitle class="text-caption white--text">
                  Día / Mes
                </v-list-item-subtitle> -->
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <break-menu mode="HOME"></break-menu>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-card
            flat
            class="bg-2 d-flex align-center"
            height="100px"
            @click="$router.push({ name: 'Tipificacion - Agentes' })"
          >
            <v-list-item>
              <v-list-item-avatar tile>
                <img src="@/assets/images/home-buttons/3.png" alt="icon" />
              </v-list-item-avatar>

              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Tipificar</v-list-item-title>

                <!-- <v-list-item-subtitle class="text-caption white--text">
                  Día / Mes
                </v-list-item-subtitle> -->
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-card
            flat
            class="bg-4 d-flex align-center"
            height="100px"
            @click="$router.push({ name: 'Devolucion de Llamadas' })"
          >
            <v-list-item>
              <v-list-item-avatar tile>
                <img src="@/assets/images/home-buttons/4.png" alt="icon" />
              </v-list-item-avatar>

              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Devolver llamadas</v-list-item-title>

                <!-- <v-list-item-subtitle class="text-caption white--text">
                  Registro detallado
                </v-list-item-subtitle> -->
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-card
            flat
            class="bg-3 d-flex align-center"
            height="100px"
            @click="$router.push({ name: 'Marcacion - Agentes' })"
          >
            <v-list-item>
              <v-list-item-avatar tile>
                <img src="@/assets/images/home-buttons/5.png" alt="icon" />
              </v-list-item-avatar>

              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Campañas</v-list-item-title>

                <!-- <v-list-item-subtitle class="text-caption white--text">
                  Creados
                </v-list-item-subtitle> -->
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>

        <!-- <v-col cols="12" sm="6" md="4" >
          <v-card
            flat
            class="bg-5 d-flex align-center"
            height="100px"
            @click="$router.push({ name: 'Pausas activas' })"
          >
            <v-list-item>
              <v-list-item-avatar tile>
                <img src="@/assets/images/home-buttons/6.png" alt="icon" />
              </v-list-item-avatar>

              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Agentes</v-list-item-title>

                <v-list-item-subtitle class="text-caption white--text">
                  En pausa
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col> -->

        <v-col cols="12" sm="6" md="4">
          <v-card flat class="bg-6 d-flex align-center" height="100px" @click="$router.push({ name: 'Formularios' })">
            <v-list-item>
              <v-list-item-avatar tile>
                <img src="@/assets/images/home-buttons/7.png" alt="icon" />
              </v-list-item-avatar>

              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Formularios</v-list-item-title>

                <!-- <v-list-item-subtitle class="text-caption white--text">
                  Formularios
                </v-list-item-subtitle> -->
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>

        <!-- <v-col cols="12" sm="6" md="4" >
          <v-card
            flat
            class="bg-7 d-flex align-center"
            height="100px"
            @click="$router.push({ name: 'Contacts' })"
          >
            <v-list-item>
              <v-list-item-avatar tile>
                <img src="@/assets/images/home-buttons/8.png" alt="icon" />
              </v-list-item-avatar>

              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Contacto</v-list-item-title>

                <v-list-item-subtitle class="text-caption white--text">
                  Configuración
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col> -->
      </v-row>

      <v-row class="d-flex d-md-none" justify="space-around">
        <v-col cols="6">
          <v-card flat class="bg-0 d-flex flex-column text-center" @click="openDialerDialog">
            <v-responsive aspect-ratio="1" class="align-center">
              <v-avatar tile>
                <img src="@/assets/images/home-buttons/3.png" alt="icon" />
              </v-avatar>
              <v-list-item>
                <v-list-item-content class="white--text text-uppercase">
                  <v-list-item-title>Marcar</v-list-item-title>

                  <!-- <v-list-item-subtitle class="text-caption white--text">
                    Marcar
                  </v-list-item-subtitle> -->
                </v-list-item-content>
              </v-list-item>
            </v-responsive>
          </v-card>
        </v-col>

        <v-col cols="6">
          <break-menu mode="HOME"></break-menu>
        </v-col>

        <v-col cols="6">
          <v-card flat class="bg-2 d-flex text-center" @click="$router.push({ name: 'Tipificacion - Agentes' })">
            <v-responsive aspect-ratio="1" class="align-center">
              <v-avatar tile>
                <img src="@/assets/images/home-buttons/3.png" alt="icon" />
              </v-avatar>

              <v-list-item>
                <v-list-item-content class="white--text text-uppercase">
                  <v-list-item-title class="text-caption">Tipificar</v-list-item-title>

                  <v-list-item-subtitle class="text-caption white--text">
                    Día / Mes
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-responsive>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card flat class="bg-4 d-flex text-center" @click="$router.push({ name: 'Devolucion de Llamadas' })">
            <v-responsive aspect-ratio="1" class="align-center">
              <v-avatar tile>
                <img src="@/assets/images/home-buttons/4.png" alt="icon" />
              </v-avatar>
              <v-list-item>
                <v-list-item-content class="white--text text-uppercase">
                  <v-list-item-title>Devolver llamadas</v-list-item-title>

                  <!-- <v-list-item-subtitle class="text-caption white--text">
                    Registro detallado
                  </v-list-item-subtitle> -->
                </v-list-item-content>
              </v-list-item>
            </v-responsive>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card flat class="bg-3 d-flex text-center" @click="$router.push({ name: 'Marcacion - Agentes' })">
            <v-responsive aspect-ratio="1" class="align-center">
              <v-avatar tile>
                <img src="@/assets/images/home-buttons/5.png" alt="icon" />
              </v-avatar>
              <v-list-item>
                <v-list-item-content class="white--text text-uppercase">
                  <v-list-item-title>Campañas</v-list-item-title>

                  <!-- <v-list-item-subtitle class="text-caption white--text">
                    Creados
                  </v-list-item-subtitle> -->
                </v-list-item-content>
              </v-list-item>
            </v-responsive>
          </v-card>
        </v-col>

        <!-- <v-col cols="6">
          <v-card
            flat
            class="bg-5 d-flex text-center"
            @click="$router.push({ name: 'Pausas activas' })"
          >
            <v-responsive aspect-ratio="1" class="align-center">
              <v-avatar tile>
                <img src="@/assets/images/home-buttons/6.png" alt="icon" />
              </v-avatar>
              <v-list-item>
                <v-list-item-content class="white--text text-uppercase">
                  <v-list-item-title>Agentes</v-list-item-title>

                  <v-list-item-subtitle class="text-caption white--text">
                    En pausa
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-responsive>
          </v-card>
        </v-col> -->

        <v-col cols="6">
          <v-card flat class="bg-6 d-flex text-center" @click="$router.push({ name: 'Formularios' })">
            <v-responsive aspect-ratio="1" class="align-center">
              <v-avatar tile>
                <img src="@/assets/images/home-buttons/7.png" alt="icon" />
              </v-avatar>
              <v-list-item>
                <v-list-item-content class="white--text text-uppercase">
                  <v-list-item-title>Formularios</v-list-item-title>

                  <!-- <v-list-item-subtitle class="text-caption white--text">
                    Formularios
                  </v-list-item-subtitle> -->
                </v-list-item-content>
              </v-list-item>
            </v-responsive>
          </v-card>
        </v-col>

        <!-- <v-col cols="6">
          <v-card
            flat
            class="bg-7 d-flex text-center"
            @click="$router.push({ name: 'Contacts' })"
          >
            <v-responsive aspect-ratio="1" class="align-center">
              <v-avatar tile>
                <img src="@/assets/images/home-buttons/8.png" alt="icon" />
              </v-avatar>
              <v-list-item>
                <v-list-item-content class="white--text text-uppercase">
                  <v-list-item-title>Contacto</v-list-item-title>

                  <v-list-item-subtitle class="text-caption white--text">
                    Configuración
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-responsive>
          </v-card>
        </v-col> -->
      </v-row>
    </v-container>
  </section>
</template>

<script>
import BreakMenu from "@/components/Breaks/BreakMenu.vue";
import { mapState } from "vuex";

export default {
  inject: ["theme"],

  components: {
    BreakMenu,
  },

  data() {
    return {
      typificationData: { temporaryTableId: null, queueNumberSelected: null },
      search: "",
      userData: {},
      // isLoadingConnect: false
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    Breaks() {
      return this.$store.getters["breaks/GET_ALL_BREAKS"];
    },

    isDark() {
      return this.$vuetify.theme.dark;
    },

    welcomeCardHeight() {
      if (this.$vuetify.breakpoint.mobile) {
        return "200";
      } else {
        return "150";
      }
    },

    isConnectedToSIP() {
      return this.$store.getters["dialer/GET_IS_CONNECTED"];
    },

    ProfileInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },

    showAgentCall() {
      const isCallsEnabled = this.ProfileInfo.web_rtc ? (this.isConnectedToSIP ? true : false) : true;
      return this.userData.role_id === 3 && isCallsEnabled;
    },

    ...mapState({
      // Breaks: state => state.breaks.allBreaks,
      extensionVariableValue: (state) => state.passport.user.variable,
    }),
  },

  mounted() {
    this.userData = JSON.parse(localStorage.getItem("user"));
  },

  methods: {
    openDialerDialog() {
      this.$store.dispatch("dialer/TOGGLE_OPEN_DIALOG");
    },
    async agentBreak(item) {
      try {
        const confirmRequest = await this.$swalconfirm(item.name, "¿Desea comenzar esta pausa?");
        if (confirmRequest.isConfirmed) {
          await this.$store.dispatch("breaks/USE_BREAK", {
            pause_id: item.id,
          });
        }
      } catch (error) {
        this.$snotify.error("No se pudo iniciar la pausa.", "¡Error!");
        // console.error(error.response.data.error);
      }
    },
  },
};
</script>

<style>
.bg-0,
.bg-3,
.bg-5 {
  background-image: linear-gradient(to right, #7c5cf5ff 0%, #9b8bf7ff 100%);
}
.bg-0:hover,
.bg-3:hover,
.bg-5:hover {
  background-image: linear-gradient(to right, #513996ff 0%, #916ddcff 100%);
}
.bg-1,
.bg-6 {
  background-image: linear-gradient(to right, #6ad4d4ff 0%, #1ac2ccff 100%);
}
.bg-1:hover,
.bg-6:hover {
  background-image: linear-gradient(to right, #4cabb8ff 0%, #0084baff 100%);
}
.bg-2,
.bg-4,
.bg-7 {
  background-image: linear-gradient(to right, #5672ddff 0%, #428de0ff 100%);
}
.bg-2:hover,
.bg-4:hover,
.bg-7:hover {
  background-image: linear-gradient(to right, #5434a2ff 0%, #4f76d8ff 100%);
}
</style>
